<script type="text/jsx">
import { mapGetters } from 'vuex';
import partnerEntryMixin from '@/views/config/partner-refer/mixin/partner-entry';

export default {
  name: 'partner-plan-cart',
  mixins: [partnerEntryMixin],
  computed: {
    ...mapGetters(['partnerMessageLoading']),
  },
  render() {
    const Comp = this.getPlanCartContent();
    return Comp ? <Comp /> : null;
  },
};
</script>

<style lang="scss">
@import '@/styles/_variables.scss';

.partner-plan-card {
  &__skeleton--wrapper {
    .zm-skeleton {
      padding: 0px !important;
    }
  }

  &__wrapper {
    margin-top: 16px;
  }
}

.opc-partner-open-offer-detail {
  white-space: nowrap;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  text-align: left;
  color: #0B5CFF;
}
</style>

